import {Component, Input, OnInit} from '@angular/core';
import {Yii} from '../../interfaces/Yii';


class Wording {
    public readonly pax: string = Yii.t("wui-sasha-js", "voyageurs");
    public readonly onePax: string = Yii.t("wui-sasha-js", "1 voyageur");
}

@Component({
    selector: 'traveller-quantity',
    template: `
        <span [ngPlural]="quantity" *ngIf="quantity" class="alignElements">
            <ng-template ngPluralCase="=1">{{labels.onePax}}</ng-template>
            <ng-template ngPluralCase="other">{{quantity}} {{labels.pax}}</ng-template>
        </span>
    `,
    styles: [`
        alignElements {
            text-align: left;
        }
    `]
})

export class TravellerQuantityComponent {
    @Input()
    public quantity: number;
    public labels: Wording = new Wording();
}
